import { Component } from '@angular/core';
import { WellData, FieldData } from '../../../_models/field';
import { PortalApiService } from '../../../_services/portal-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserProfile } from '../../../_models/user-profile';
import { UserProfileService } from '../../../_services/user-profile.service';
import { CloudFile, Folder } from '../../../_models/files';
import { FileHelperService } from '../../../_services/file-helper.service';
import { ListsHelperService } from '../../../_services/lists-helper.service';

@Component({
  selector: 'app-add-well-file',
  templateUrl: './add-well-file.component.html',
  styleUrls: ['./add-well-file.component.css']
})
export class AddWellFileComponent {
  userProfile: UserProfile;
  wellID: any = null;
  receivedFolder: Folder;
  wellFiles: CloudFile[];
  isLoadingFiles: boolean = false;
  noImagesAvailable: boolean = false;
  errorRetrievingFiles: boolean = false;
  errorMessage: string;
  tableDisplay: boolean = false;
  filesQuery: string = '';
  wellFilesSort = {
    fileName: false,
    size: false,
    createdOn: false
  };
  searchableProps: string[] = [
    'fileName',
    'description'
  ];
  private onDestroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private apiService: PortalApiService,
    private userService: UserProfileService,
    private fileHelperService: FileHelperService,
    private sanitizer: DomSanitizer,
    private listHelper: ListsHelperService
  ) {
    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(
      currentProfile => this.userProfile = currentProfile);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.wellID = +params['wellId'];
      if (this.wellID && this.wellID != null) {
        this.getFilesForWell();
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  getFilesForWell() {
    this.isLoadingFiles = true;
    this.noImagesAvailable = false;
    this.errorMessage = null;
    this.errorRetrievingFiles = false;
    this.wellFiles = [];

    this.apiService.getFileListForWell(this.wellID).subscribe({
      next: (data: Folder) => {
        this.receivedFolder = data;

        /* Handle well files */
        data.files.forEach(receivedWellFile => {
          let file: CloudFile = receivedWellFile;
          file.downloading = false;
          file.error = false;
          file.loading = false;
          file.fileType = this.fileHelperService.returnFileTypeFromFileName(file.fileName);
          //let fileWithImageUrl: CloudFile = this.retrieveWellFileUrlForImages(file, this.wellID);

          this.wellFiles.push(file);
        })

        if (data.subFolders.length > 0) {
        }
        else {
          this.noImagesAvailable = true;
        }

        this.isLoadingFiles = false;
      },
      error: err => {
        console.log(err);
        this.isLoadingFiles = false;
        this.errorRetrievingFiles = true;
        this.errorMessage = (err.error || 'Failed to retrieve file list');
      }
    })
  }

  //retrieveWellFileUrlForImages(file: CloudFile, wellID: number): CloudFile {
  //  if (file.fileType == 'image') {
  //    file.loading = true;
  //    this.apiService.downloadFileForWell(wellID, file.fileName).subscribe({
  //      next: (result: any) => {
  //        if (result.type != 'text/plain') {
  //          let objectURL = URL.createObjectURL(result);
  //          file.fileUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
  //          file.loading = false;
  //        }
  //        else {
  //          file.loading = false;
  //          file.error = true;
  //        }
  //      }
  //    });
  //  }

  //  return file;
  //}

  wellFileUploadHandler(fileData: CloudFile) {
    fileData.fileType = this.fileHelperService.returnFileTypeFromFileName(fileData.fileName);
    if (fileData.fileType == 'image') {
      fileData.loading = true;
      this.wellFiles.unshift(fileData);

      this.apiService.downloadFileForWell(this.wellID, fileData.fileName).subscribe({
        next: result => {
          if (result.type != 'text/plain') {
            let objectURL = URL.createObjectURL(result);

            fileData.loading = false;
            fileData.downloading = false;
            fileData.error = false;
            fileData.fileUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
            this.wellFiles[0] = fileData;
          }
        },
        error: err => {
          console.log(err);
          fileData.loading = false;
          fileData.downloading = false;
          fileData.error = true;
          this.wellFiles[0] = fileData;
        }
      })
    }
    else {
      this.wellFiles.unshift(fileData);
    }

  }

  wellFileDeletedHandler(fileData: CloudFile) {
    const indexToDelete: number = this.wellFiles.findIndex(file => file.fileName == fileData.fileName);
    this.wellFiles.splice(indexToDelete, 1);
  }


  wellFileUpdatedHandler(updatedFile: CloudFile) {
    const index: number = this.wellFiles.findIndex(file => file.fileName == updatedFile.fileName);
    this.wellFiles[index] = updatedFile;
  }

  swapViews(displayTableStyle: boolean) {
    this.tableDisplay = displayTableStyle;
  }

  sortListBy(column: string | any) {
    this.wellFiles.sort(this.listHelper.sortProperty(column, this.wellFilesSort[column]));
    this.wellFilesSort[column] = !this.wellFilesSort[column];
  }
}
